import { Component } from '@angular/core';

@Component({
  selector: 'bko-okonomi-card',
  imports: [
  ],
  templateUrl: './okonomi-card.html',
  styleUrl: './okonomi-card.scss'
})
export class OkonomiCard {

}
